import { render } from "./InternalDocumentsPage.vue?vue&type=template&id=27081c7e"
import script from "./InternalDocumentsPage.vue?vue&type=script&lang=js"
export * from "./InternalDocumentsPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__